import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  AvailableDatesRequest,
  AvailableDatesResponse,
  BusinessAvailableDatesRequest,
} from '../interfaces/appointment-time.model';

/**
 * 選擇預約時間service
 */
@Injectable({
  providedIn: 'root',
})
export class AppointmentTimeService {
  http: HttpClient = inject(HttpClient);
  orgNoInfo: Record<string, string[]> = {
    '01': [
      '1. 「皮質素」為求檢查數值正常，報到時段請選擇 08：30 以前。',
      '2. 「高階影像」請按照專人與您聯繫的時間進行報到。'
    ],
    '02': [
      '1. 「皮質素」為求檢查數值正常，報到時段請選擇 08：30 以前。',
      '2. 「高階影像」請按照專人與您聯繫的時間進行報到。'
    ],
    '04': [
      '1. 「皮質素」為求檢查數值正常，報到時段請選擇 08：30 以前。',
      '2. 「高階影像」請按照專人與您聯繫的時間進行報到。',
      '3. 「肝纖維化掃描」、「腹部超音波」與「碳-13幽門桿菌呼氣試驗」，請選擇 10：30 以前報到，已確保檢查流程順暢及檢查品質。',
    ],
    '05': [
      '1. 「皮質素」為求檢查數值正常，報到時段請選擇 08：30 以前。',
      '2. 「高階影像」、「內視鏡」、「肝纖維化掃描」、「婦科」、「心臟」、或較多檢查項目者，請選擇 08：00 以前報到，已確保檢查流程順暢及檢查品質。',
    ]
  };
  /**
   * 查詢可預約之日期
   * @param request 查詢可預約之日期請求
   */
  getAvailableDates(
    request: AvailableDatesRequest
  ): Observable<ApiResponse<AvailableDatesResponse>> {
    // TODO 改使用post請求
    // return this.axiosHttpService.post(API_ENDPOINTS.AVAILABLE_DATES, request)
    return this.http.post<ApiResponse<AvailableDatesResponse>>(
      API_ENDPOINTS.AVAILABLE_DATES,
      request
    );
  }

  /**
   * 企業查詢可預約之日期
   * @param request 企業查詢可預約之日期請求
   */
  getBusinessAvailableDates(
    request: BusinessAvailableDatesRequest
  ): Observable<ApiResponse<AvailableDatesResponse>> {
    
    return this.http.post<ApiResponse<AvailableDatesResponse>>(
      API_ENDPOINTS.BUSINESS_AVAILABLE_DATES,
      request
    );
  }
}
